'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styled = require('styled-components');

var durationSlow = styled.css(["0.3s"]);
var durationBase = styled.css(["0.2s"]);
var durationFast = styled.css(["0.1s"]);
var easeBaseOut = styled.css(["cubic-bezier(0.7,0.3,0.1,1)"]);
var easeOutCircle = styled.css(["cubic-bezier(0.08,0.82,0.17,1)"]);
var easeInOutCircle = styled.css(["cubic-bezier(0.78,0.14,0.15,0.86)"]);
var motionIn = styled.css(["", ""], function (_ref) {
  var animationName = _ref.animationName,
      animationDuration = _ref.animationDuration,
      animationTiming = _ref.animationTiming;
  return "".concat(animationName, "In ").concat(animationDuration || durationBase, " ").concat(animationTiming || easeOutCircle);
});
var motionOut = styled.css(["", ""], function (_ref2) {
  var animationName = _ref2.animationName,
      animationDuration = _ref2.animationDuration,
      animationTiming = _ref2.animationTiming;
  return "".concat(animationName, "Out ").concat(animationDuration || durationBase, " ").concat(animationTiming || easeInOutCircle);
});

exports.durationBase = durationBase;
exports.durationFast = durationFast;
exports.durationSlow = durationSlow;
exports.easeBaseOut = easeBaseOut;
exports.easeInOutCircle = easeInOutCircle;
exports.easeOutCircle = easeOutCircle;
exports.motionIn = motionIn;
exports.motionOut = motionOut;
